import React from "react";
import { COMPARE_ROWS } from "../marketingData";
import { CheckIcon, CrossIcon } from "../shared/icons";

const CompareSection = () => (
  <div className="compare-section">
    <div className="compare-inner">
      <div className="compare-header reveal">
        <span className="section-eyebrow">Why switch</span>
        <h2 className="section-h2">
          Why serious sellers
          <br />
          <em>switch to Ecomdropship.</em>
        </h2>
      </div>
      <div className="compare-table reveal">
        <div className="compare-head">
          <div className="ch-item">Feature</div>
          <div className="ch-item highlight">Ecomdropship</div>
          <div className="ch-item">Others</div>
        </div>
        {COMPARE_ROWS.map((row) => (
          <div className="compare-row" key={row.feature}>
            <div className="cr-item feature">{row.feature}</div>
            <div className="cr-item">
              <span className="check-y">
                <CheckIcon />
              </span>{" "}
              {row.us}
            </div>
            <div className="cr-item">
              <span className="check-n">
                <CrossIcon />
              </span>{" "}
              {row.them}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const StatsSection = () => (
  <div className="stats-section">
    <div className="stats-inner">
      <div className="stat-card reveal stagger-1">
        <div className="stat-num" data-target="98">
          0%
        </div>
        <div className="stat-label">Average on-time fulfillment rate across active suppliers</div>
      </div>
      <div className="stat-card reveal stagger-2">
        <div className="stat-num" data-target="3200">
          0+
        </div>
        <div className="stat-label">Active sellers relying on Ecomdropship</div>
      </div>
      <div className="stat-card reveal stagger-3">
        <div className="stat-num">3–5 days</div>
        <div className="stat-label">Average US shipping time — enforced, not estimated</div>
      </div>
      <div className="stat-card reveal stagger-4">
        <div className="stat-num">&lt;4hr</div>
        <div className="stat-label">Average support response time — measured in hours, not days</div>
      </div>
    </div>
  </div>
);

export { CompareSection, StatsSection };
